<div ngbDropdown class="vox-dropdown-input dropdown-entry-container" *ngIf="!isLoading">
  <button ngbDropdownToggle class="dropdown-toggle dropdown-entry-toggle" type="button">
    <span *ngIf="currentSelected" class="dropdown-entry-selected"><span>
        <b>{{currentSelected.brand}}</b> {{currentSelected.model}}
      </span>
      <span>
        <gdp-connectivity-entry-type class="dropdown-entry-end" [type]="currentSelected.type">
        </gdp-connectivity-entry-type>
      </span></span>
    <span *ngIf="!currentSelected" class="dropdown-entry-no-selected"
      translate>connectivity.entry-search.no-selected</span>
  </button>
  <div ngbDropdownMenu class="dropdown-entry-menu">
    <div class="dropdown-entry-search-container">
      <i class="icon-small-search"></i>
      <input type="text" class="dropdown-entry-search vox-text-field"
        [placeholder]="'connectivity.entry-search.placeholder' | translate" (keypress)="onKeypress($event)"
        (input)="onFilterEntries($event)" [(ngModel)]="searchTerm">
    </div>
    <div class="dropdown-entry-items">
      <div ngbDropdownItem *ngFor="let entry of filteredCatalogList" class="dropdown-entry-item"
        (click)="onSelectEntry(entry)">
        <span>
          <b>{{entry.brand}}</b> {{entry.model}}
        </span>
        <span>
          <gdp-connectivity-entry-type class="dropdown-entry-end" [type]="entry.type"></gdp-connectivity-entry-type>
        </span>
      </div>
      <div ngbDropdownItem *ngIf="filteredCatalogList.length === 0" class="dropdown-entry-no-item" disabled translate>
        connectivity.entry-search.no-item</div>
    </div>
  </div>
</div>

<div class="dropdown-entry-container" *ngIf="isLoading">
  <ngx-skeleton-loader [theme]="{'height': '40px', 'width': '100%'}"></ngx-skeleton-loader>
</div>